import React from 'react';
import { useTranslation } from 'react-i18next';
import './TimeWindowSelector.css';

const TimeWindowSelector = ({
  timeWindow,
  onChange
}) => {
  const { t } = useTranslation(['discovery']);

  return (
    <div className="time-window-selector">
      <select
        id="time-window"
        className="time-window-selector__select"
        value={timeWindow}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="day">{t('videoDiscovery.filters.timeWindows.day')}</option>
        <option value="week">{t('videoDiscovery.filters.timeWindows.week')}</option>
        <option value="month">{t('videoDiscovery.filters.timeWindows.month')}</option>
        <option value="year">{t('videoDiscovery.filters.timeWindows.year')}</option>
      </select>
    </div>
  );
};

export default TimeWindowSelector;